import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import TimeList from '@/user/components/fair/time_list';
import Calendar from '@/user/components/fair/calendar';
import ModalButton from '@/user/components/fair/reserve_button';
import moment from 'moment';
import laroute from '@/shared/laroute';
import Axios from 'axios';
import { sliderSetting, setColorClass } from '@/shared/calendar';
import { ClipLoader } from 'react-spinners';

function ModalStatus({startOfMonth, webReservePeriodDate}) {
    // モーダルの表示非表示
    const [isModalOpen, setIsModalOpen] = useState(false);
    // カレンダーで選択された日付
    const [selectedCalenderDate, setSelectedCalenderDate] = useState('');
    // 日付ごとのフェアデータ
    const [fairDays, setFairDays] = useState({});
    // カレンダー初期日付（日付順）
    const [initializeDate, setInitializeDate] = useState('');
    // モーダルのボタンの表示非表示
    const [isShowModalBtn, setIsShowModalBtn] = useState(false);
    const [fairId, setFairId] = useState(0);
    // 予約可能である
    const [canReserve, setCanReserve] = useState(true);
    // 注意文言
    const [noteText, setNoteText] = useState('');
    // ローディングの表示非表示
    const [isLoading, setIsLoading] = useState(true);

    const handleCloseModal = () => {
        setSelectedCalenderDate('');
        setInitializeDate('');
        setColorClass(); // カレンダー色調整
        setIsModalOpen(false);
        setIsShowModalBtn(false);
        setCanReserve(true);
        setNoteText('');
        setIsLoading(true);
    };

    // 詳細画面のURLを生成
    const showLink = laroute.route('user.fair.show', {
        fairId: fairId,
    }); // クエリストリングがつくので末尾に / を入れない

    // 予約画面のURLを生成
    const reserveLink = laroute.route('user.reservation.create', {
        fair_id: fairId,
    }); // クエリストリングがつくので末尾に / を入れない

    // フェアごとのチェック
    const isReservableFair = (webReservePeriodDate, fairDays) => {
        let reservableDays = []; // 予約期限内の日付一覧
        let reminderDays = []; // 残席ありの日付一覧
        let note = '';
        Object.values(fairDays).map(fairDay => {
            fairDay.map(day => {
                // 予約期限がすぎてない
                if (! isNotReservableDay(day.date, webReservePeriodDate)) {
                    reservableDays.push(day);
                }
            });
        });

        // 予約ができるフェアが0の場合
        if (reservableDays.length === 0) {
            note = `※${webReservePeriodDate}日以内のご予約は、別の日付をご選択もしくは、会場に直接お問合せ下さい。`;
        }

        // 予約ができるフェアが1件でもある場合は残席をチェックする
        if (reservableDays.length > 0) {
            reservableDays.map(day => {
                if (! isFullReserveReminder(day)) {
                    reminderDays.push(day.date);
                }
            })
            // 残席があるフェアが0の場合（すべて満席の場合）
            if (reminderDays.length === 0) {
                note = '※こちらのフェアは全日程満席です。';
            }
        }

        return note;
    }

    useEffect(() => {
        const openModal = document.getElementsByClassName('js-modal_reserve_open');

        const handleOpenModal = (e) => {
            e.preventDefault();
            // checked を外す
            const checkedInputs = document.querySelectorAll('#js-calendar_fair_reserve_modal input[type=checkbox]:checked');
            checkedInputs.forEach((checkedInput) => {
                checkedInput.checked = false;
            });
            // カレンダーの色調整
            setColorClass();
            setIsModalOpen(true);
            const cassette = e.currentTarget;
            setFairId(cassette.dataset.fair_id);

            // API実行
            handleFairAPIRequest(cassette.dataset.fair_id, setFairDays).then(fairDates => {
                const note = isReservableFair(webReservePeriodDate, fairDates);
                if (note) {
                    setCanReserve(false);
                    setIsShowModalBtn(true);
                    setNoteText(note);
                }
                setIsLoading(false);
            });

            const targetDate = cassette.dataset.date;
            if (targetDate && isNotReservableDay(targetDate, webReservePeriodDate)) {
                setCanReserve(false);
                setIsShowModalBtn(true);
                setNoteText(`※${webReservePeriodDate}日以内のご予約は、別の日付をご選択もしくは、会場に直接お問合せ下さい。`);
            }
            setInitializeDate(targetDate);
        };

        if (openModal) {
            Array.from(openModal).forEach(cassette => {
                cassette.addEventListener('click', handleOpenModal);
            });
        }

        return () => {
            if (openModal) {
                Array.from(openModal).forEach(cassette => {
                    cassette.removeEventListener('click', handleOpenModal);
                });
            }
        };
    }, []);

    useEffect(() => {
        if (!isLoading) {
            // カレンダーのカルーセル
            sliderSetting(true, false);

            // カレンダーの日付
            const inputDateCheckBox = document.querySelectorAll('#js-calendar_fair_reserve_modal input[name="date[]"]');

            if (inputDateCheckBox) {
                inputDateCheckBox.forEach(checkDay => {
                    checkDay.addEventListener('click', function() {
                        setSelectedCalenderDate(checkDay.value);
                        setInitializeDate('');
                        setIsShowModalBtn(false);
                        setCanReserve(true);
                    });
                });
            }
        }
    }, [isLoading]);

    return (
        <div className={`fair-modal ${isModalOpen ? 'is-active' : ''}`} id="fair-modal">
            <div className="fair-modal__overlay" onClick={() => handleCloseModal()} />
            <div className="fair-modal__container">
                <div className="fair-modal__close color--text" onClick={() => handleCloseModal()}>×</div>
                <div className="fair-modal__content background-color--page_bg">
                    <div id="fair-search-reserve" className="fair-search-reserve">
                        <div className="fair-search-reserve__head">
                            <p className="fair-search-reserve__title color--accent font-family--middle">日時を選択してフェアを予約</p>
                        </div>
                        {/* ローディング */}
                        {isLoading ? (
                            <ClipLoader
                                className={'fair-modal__loading border-color--accent'}
                                size={40}
                                height = {80}
                                width = {80}
                                loading={isLoading} />
                        ) : (
                            <>
                                {/* カレンダー表示 */}
                                <Calendar
                                    startOfMonth={startOfMonth}
                                    fairDays={fairDays}
                                    webReservePeriodDate={webReservePeriodDate}
                                    selectedDate={selectedCalenderDate ? [selectedCalenderDate] : []}
                                    initializeDate={initializeDate}
                                    type={'fair_reserve_modal'}
                                />
                                {!canReserve && (
                                    <p className="fair-search-reserve__note color--text font-family--middle">
                                        {noteText}
                                    </p>
                                )}
                                {Object.entries(fairDays).map((fairDay, i) => {
                                    const date = initializeDate || selectedCalenderDate;

                                    // 選択した日付の開催日でない場合は非表示
                                    if (fairDay[0] !== date) {
                                        return null;
                                    }
                                    // 選択した日付の時間がない時は非表示
                                    if (!fairDay[1][0]) {
                                        return null;
                                    }
                                    // 予約可能な日をすぎた場合
                                    if (isNotReservableDay(date, webReservePeriodDate)) {
                                        return null;
                                    }
                                    // 予約できない場合は非表示
                                    if (!canReserve) {
                                        return null;
                                    }
                                    const dayTime = fairDay[1][0];
                                    return (
                                        <div key={i}>
                                            <p className="fair-search-reserve__subtitle color--text font-family--middle">時間を選択</p>
                                            <TimeList
                                                times={dayTime.times}
                                                date={date}
                                                showLink={showLink}
                                                fairId={fairId}
                                            />
                                        </div>
                                    );
                                })}
                                {isShowModalBtn && (
                                    <ModalButton
                                        reserveLink={reserveLink}
                                        showLink={showLink}
                                        canReserve={canReserve}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

// 予約可能な日をすぎた場合
const isNotReservableDay = (date, webReservePeriodDate) => {
    const reserveDate = moment(date);
    const toDay = moment().format("YYYY-MM-DD");
    let reservableDay = moment(toDay);

    if (webReservePeriodDate > 0) {
        reservableDay = reservableDay.add(webReservePeriodDate, 'days').format();
    }

    return reserveDate.isBefore(reservableDay);
}

// 日付ごとの満席チェック
const isFullReserveReminder = (fairDays) => {
    return fairDays.times.every(time => time.remainder === '2');
}

/**
 * APIアクセス
 * @param {array} $params
 * @returns {json}
 */
const api = ($params) => {
    const endpoint = laroute.route('user.api.fair.dateTime') + '/';

    return Axios.get(endpoint,{
        params: $params
    });
}

/**
 *フェアAPIの実行
 * @param {number} fairId 指定されたフェアID
 * @param {number} fairsTotal 該当するフェアの日付データ
 */
const handleFairAPIRequest = (fairId, setFairDays) => {
    return api({ 'fair_id': fairId }).then(({ data }) => {
        setFairDays(data.fairDate);
        return data.fairDate;
    });
};

/**
 * startOfMonth: カレンダー開始日(YYYY-mm-dd)
 * webReservePeriodDate: オンライン予約の受付期限（日数）
 */
ModalStatus.propTypes = {
    startOfMonth: PropTypes.string.isRequired,
    webReservePeriodDate: PropTypes.string.isRequired,
};

export default ModalStatus;
